export default __webpack_public_path__ + "static/media/1274.fc527282.png";